/**
 * Teals Design System - Typography Tokens
 *
 * Typography scale and font definitions.
 */
export const fontFamilies = {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    secondary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
};
export const fontWeights = {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
export const fontSizes = {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    base: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem', // 48px
    '6xl': '3.75rem', // 60px
};
export const lineHeights = {
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
};
export const letterSpacings = {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
};
// Pre-defined text styles
export const textStyles = {
    h1: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes['5xl'],
        fontWeight: fontWeights.bold,
        lineHeight: lineHeights.tight,
        letterSpacing: letterSpacings.tight,
    },
    h2: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes['4xl'],
        fontWeight: fontWeights.bold,
        lineHeight: lineHeights.tight,
        letterSpacing: letterSpacings.tight,
    },
    h3: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes['3xl'],
        fontWeight: fontWeights.semibold,
        lineHeight: lineHeights.snug,
        letterSpacing: letterSpacings.normal,
    },
    h4: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes['2xl'],
        fontWeight: fontWeights.semibold,
        lineHeight: lineHeights.snug,
        letterSpacing: letterSpacings.normal,
    },
    h5: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes.xl,
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.normal,
        letterSpacing: letterSpacings.normal,
    },
    h6: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes.lg,
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.normal,
        letterSpacing: letterSpacings.normal,
    },
    body1: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes.base,
        fontWeight: fontWeights.regular,
        lineHeight: lineHeights.normal,
        letterSpacing: letterSpacings.normal,
    },
    body2: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.regular,
        lineHeight: lineHeights.normal,
        letterSpacing: letterSpacings.normal,
    },
    caption: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes.xs,
        fontWeight: fontWeights.regular,
        lineHeight: lineHeights.normal,
        letterSpacing: letterSpacings.wide,
    },
    button: {
        fontFamily: fontFamilies.primary,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.normal,
        letterSpacing: letterSpacings.wide,
        textTransform: 'uppercase',
    },
    code: {
        fontFamily: fontFamilies.mono,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.regular,
        lineHeight: lineHeights.relaxed,
        letterSpacing: letterSpacings.normal,
    },
};
export const typography = {
    fontFamilies,
    fontWeights,
    fontSizes,
    lineHeights,
    letterSpacings,
    textStyles,
};
